var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-image",
    d: "M24,4.342V6.237H21.158V9.079H19.263V6.237H16.421V4.342h2.842V1.5h1.895V4.342Zm-8.053,6.632a1.422,1.422,0,1,0-1.422-1.421,1.422,1.422,0,0,0,1.422,1.421Zm3.316,3.064-.486-.54a1.895,1.895,0,0,0-2.819,0l-.621.692-4.6-5.11L7.895,12.237v-6h6.632V4.342H7.895A1.9,1.9,0,0,0,6,6.237V17.605A1.9,1.9,0,0,0,7.895,19.5H19.263a1.9,1.9,0,0,0,1.895-1.895V10.974H19.263Z",
    transform: "translate(-6 -1.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/addImage.a34945fd4f9ab10c7fcab0dc3ff16d5b.svg";
export { ForwardRef as ReactComponent };